// BookTickets/stages/PaymentProcess/lib/paymentLocale.ts
export function mapLocaleToGateway(locale: string): 'en' | 'pt' {
  if (locale === 'pt-PT') return 'pt'
  return 'en'
}
